import { getCoverage } from '@angle/utils'
import React, { useRef } from 'react'
import {
  Button,
  CenteredSpinner,
  Container,
  IDCard
} from 'react-angle-dashboard-components'
import ReactToPrint from 'react-to-print'

export const IDCardContainer: React.FC<{
  isLoading: boolean
  data: any
  isDependent?: boolean
}> = ({ isLoading, data }) => {
  const cardRef = useRef<any>()
  const planCoverage = getCoverage(data)

  if (!planCoverage && !isLoading) {
    return (
      <Container>
        <div>No coverage information available.</div>
      </Container>
    )
  }

  if (data?.member_id && data.member_id.length === 12) {
    data.member_id = data.member_id.substring(0, 10)
  }

  return (
    <Container className="pt-2 mb-4" style={{ paddingBottom: 100 }}>
      {isLoading ? (
        <CenteredSpinner />
      ) : (
        <>
          <div ref={cardRef} className="pt-3">
            <IDCard data={data} />
          </div>
          <ReactToPrint
            trigger={() => (
              <div className="text-center">
                <Button>Print card</Button>
              </div>
            )}
            content={() => cardRef.current}
          />
        </>
      )}
    </Container>
  )
}
